export class ApplicationModel {
	private static _instance: ApplicationModel = null;
	private static _singletonEnforcer: boolean;
	private _textDirection = "ltr";
	private isLastPageReached: Boolean = false;
	private _nextExpectedRubric: string = "";
	private _mode = "demo";
	private _presMode = "";
	private _videoOverlay: boolean = true;
	private _audioModeChangeOverlay: boolean = false;
	private _audioOverlayInVideoMode: boolean = true;
	private _unmuteAudioOnRubricLoad: boolean = false;
	private _muteAudioVideo: boolean = false;
	private _showTranscript: boolean = false;
	private _contentVersion: string = "";
	private _skipTo: string = "";
	private _isAdaptivePlayer: boolean;
	private _adaptiveLearningFlow: string = "";
	private _playerSpeed: number;
    private _isPresModeWindowOpen: boolean = true;

	constructor() {
		if (!ApplicationModel._singletonEnforcer) {
			throw new Error(
				"This is a singleton class. Use ApplicationModel.instance to get the instance!!"
			);
		}
	}

	public static get instance(): ApplicationModel {
		if (this._instance == null) {
			this._singletonEnforcer = true;
			this._instance = new ApplicationModel();
			this._singletonEnforcer = false;
		}
		return this._instance;
	}

	public get flowDirection() {
		return this._textDirection;
	}

	public set flowDirection(val) {
		this._textDirection = val;
	}

	public get showTranscript() {
		return this._showTranscript;
	}

	public set showTranscript(val) {
		this._showTranscript = val;
	}
	public get textDirection() {
		if(this._textDirection &&  (this._textDirection).toLowerCase() == "rtl")
		return "right";
		else return "left";
	}

	public set bLastPageReached(bVal) {
		this.isLastPageReached = bVal;
	}

	public get bLastPageReached() {
		return this.isLastPageReached;
	}

	public set nextExpectedRubric(val: string) {
		this._nextExpectedRubric = val.toLowerCase();
	}

	public get nextExpectedRubric() {
		return this._nextExpectedRubric;
	}
	public get mode() {
		return this._mode;
	}

	public set mode(val) {
		this._mode = val;
	}

	public get presMode() {
		return this._presMode;
	}

	public set presMode(val) {
		this._presMode = val;
	}

	public get videoOverlay() {
		return this._videoOverlay;
	}

	public set videoOverlay(val) {
		this._videoOverlay = val;
	}

	public get audioModeChangeOverlay() {
		return this._audioModeChangeOverlay;
	}

	public set audioModeChangeOverlay(val) {
		this._audioModeChangeOverlay = val;
	}

	public get audioOverlayInVideoMode() {
		return this._audioOverlayInVideoMode;
	}

	public set audioOverlayInVideoMode(val) {
		this._audioOverlayInVideoMode = val;
	}

	public get unmuteAudioOnRubricLoad() {
		return this._unmuteAudioOnRubricLoad;
	}

	public set unmuteAudioOnRubricLoad(val) {
		this._unmuteAudioOnRubricLoad = val;
	}
	public get muteAudioVideo() {
		return this._muteAudioVideo;
	}

	public set muteAudioVideo(val) {
		this._muteAudioVideo = val;
	}
	public set contentVersion(val) {
		this._contentVersion = val;
	}
	public get contentVersion() {
		return this._contentVersion;
	}

	public set skipTo(val) {
		this._skipTo = val;
	}
	public get skipTo() {
		return this._skipTo;
	}

	public get isAdaptivePlayer(): boolean {
		return this._isAdaptivePlayer;
	}

	public set isAdaptivePlayer(val: boolean) {
		this._isAdaptivePlayer = val;
	}

	public get adaptiveLearningFlow(): string {
		return this._adaptiveLearningFlow;
	}

	public set adaptiveLearningFlow(val: string) {
		this._adaptiveLearningFlow = val;
	}

	public get playerSpeed() {
		return this._playerSpeed;
	}
	public set playerSpeed(val) {
		this._playerSpeed = val;
	}

    public set isPresModeWindowOpen(val) {
        this._isPresModeWindowOpen = val;
    }
    public get isPresModeWindowOpen() {
        return this._isPresModeWindowOpen;
    }
	
}
